import type { Campaign } from '@/types';
import {
  CATEGORY_ICON_REGISTRY,
  normalizeCategoryIconKey,
} from '@/utils/categoryIconRegistry';

export interface CategoryIconMeta {
  color: string;
  label: string;
}

const NAME_TO_ICON: Record<string, string> = {
  'Meyve & Sebze': 'apple',
  'Et & Tavuk': 'drumstick',
  'Kuru Gıda': 'sprout',
  'Süt Ürünleri': 'milk',
  İçecek: 'wine',
  İçecekler: 'wine',
  Elektronik: 'plug',
  Temizlik: 'sparkles',
  Ambalaj: 'package-open',
  'Unlu Mamül': 'croissant',
};

export function resolveCategoryIcon(name: string, icon?: string): string {
  if (icon) return normalizeCategoryIconKey(icon);
  return normalizeCategoryIconKey(NAME_TO_ICON[name]);
}

export function categoryIconMeta(iconKey: string): CategoryIconMeta {
  const key = normalizeCategoryIconKey(iconKey);
  const def = CATEGORY_ICON_REGISTRY.get(key);
  return def ? { color: def.color, label: def.label } : { color: '#ff6b00', label: 'Kategori' };
}

export function CategoryIcon({
  name,
  icon,
  size = 28,
  className,
}: {
  name: string;
  icon?: string;
  size?: number;
  className?: string;
}) {
  const key = resolveCategoryIcon(name, icon);
  const def = CATEGORY_ICON_REGISTRY.get(key) ?? CATEGORY_ICON_REGISTRY.get('tag')!;
  const { Icon, color } = def;

  return (
    <Icon
      aria-hidden
      size={size}
      strokeWidth={2}
      className={className}
      style={{ color }}
    />
  );
}

export { CATEGORY_ICON_OPTIONS, CATEGORY_ICON_GROUPS, normalizeCategoryIconKey } from '@/utils/categoryIconRegistry';

export function formatCampaignCondition(campaign: Campaign): string {
  if (campaign.type === 'buy_x_pay_y' && campaign.buyQuantity && campaign.payQuantity) {
    return `${campaign.buyQuantity} Al ${campaign.payQuantity} Öde`;
  }
  if (campaign.type === 'quantity_discount' && campaign.minQuantity && campaign.discountRate != null) {
    return `${campaign.minQuantity} Adet Alıma %${campaign.discountRate} İndirim`;
  }
  if (campaign.description) return campaign.description;
  return 'Kampanya detayları';
}
